import BaseProxy from './base.proxy';

class PromotionProxy extends BaseProxy {
  buildQuery(path, query = {}) {
    const params = new URLSearchParams();
    Object.keys(query || {}).forEach((key) => {
      const value = query[key];
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value);
      }
    });
    const queryString = params.toString();
    return `${path}${queryString ? `?${queryString}` : ''}`;
  }

  promotions(query = {}) {
    return this.get(this.buildQuery('/admin/promotions', query));
  }

  promotionCodes(query = {}) {
    return this.get(this.buildQuery('/admin/promotion-codes', query));
  }

  createPromotionCode(payload) {
    return this.post('/admin/promotion-codes', payload);
  }

  deletePromotionCode(id) {
    return this.delete(`/admin/promotion-codes/${id}`);
  }
}

export default new PromotionProxy();
